import React from 'react';
import { motion } from 'framer-motion';
interface PricingSectionProps {
  selectedPlan: number;
  setSelectedPlan: (index: number) => void;
}
export function PricingSection({
  selectedPlan,
  setSelectedPlan
}: PricingSectionProps) {
  const plans = [{
    name: 'Plan Base',
    emoji: '📋',
    desc: '3 Módulos + 1 Bono',
    originalPrice: '$49.990',
    price: '$19.990',
    highlight: false,
    url: 'https://checkout.empezahoy.shop/cart/48171699110120:1'
  }, {
    name: 'Plan PRO',
    emoji: '🏆',
    desc: '5 Módulos + 3 Bonos completos',
    originalPrice: '$69.990',
    price: '$24.990',
    highlight: true,
    badge: '⭐ MÁS ELEGIDO',
    savings: 'AHORRÁS $45.000',
    url: 'https://checkout.empezahoy.shop/cart/48171698487528:1'
  }, {
    name: 'Biblioteca Completa',
    emoji: '📚',
    desc: 'Plan PRO + Recursos Extra',
    originalPrice: '$89.990',
    price: '$31.990',
    highlight: false,
    url: 'https://checkout.empezahoy.shop/cart/48171699372264:1'
  }];
  const handleCheckout = () => {
    window.open(plans[selectedPlan].url, '_blank');
  };
  return <section id="comprar" className="py-16 bg-emerald-950" data-id="element-124">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-126">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-3" data-id="element-127">
            Elegí tu plan
          </h2>
          <p className="text-lg text-emerald-300 font-medium max-w-2xl mx-auto" data-id="element-128">
            Acceso inmediato y de por vida. Pago único, sin suscripciones.
          </p>
        </motion.div>

        <div className="space-y-4 mb-8" data-id="element-129">
          {plans.map((plan, index) => {
          const isSelected = selectedPlan === index;
          const isPro = index === 1;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.4
          }} onClick={() => setSelectedPlan(index)} className={`relative cursor-pointer rounded-2xl p-5 md:p-6 border-2 transition-all duration-200 flex items-center gap-4 md:gap-6
                  ${isSelected && isPro ? 'bg-emerald-900/80 border-yellow-400 shadow-[0_0_15px_rgba(250,204,21,0.15)]' : ''}
                  ${isSelected && !isPro ? 'bg-emerald-900/80 border-emerald-400' : ''}
                  ${!isSelected ? 'bg-emerald-900/40 border-emerald-800/80 hover:border-emerald-700' : ''}
                `} data-id="element-130">
                {/* Radio Button */}
                <div className="flex-shrink-0 flex items-center justify-center" data-id="element-131">
                  <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors
                    ${isSelected && isPro ? 'border-yellow-400' : ''}
                    ${isSelected && !isPro ? 'border-emerald-400' : ''}
                    ${!isSelected ? 'border-emerald-600' : ''}
                  `} data-id="element-132">
                    {isSelected && <div className={`w-3 h-3 rounded-full ${isPro ? 'bg-yellow-400' : 'bg-emerald-400'}`} data-id="element-133" />}
                  </div>
                </div>

                {/* Plan Info */}
                <div className="flex-grow min-w-0" data-id="element-134">
                  <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-135">
                    <span className="text-xl" data-id="element-136">{plan.emoji}</span>
                    <h3 className="text-lg md:text-xl font-extrabold text-white uppercase tracking-wide" data-id="element-137">
                      {plan.name}
                    </h3>
                  </div>

                  {(plan.badge || plan.savings) && <div className="flex flex-wrap items-center gap-2 mb-2" data-id="element-138">
                      {plan.badge && <span className="bg-yellow-400 text-yellow-900 text-[10px] md:text-xs font-bold uppercase px-2 py-0.5 rounded-full" data-id="element-139">
                          {plan.badge}
                        </span>}
                      {plan.savings && <span className="bg-yellow-900/40 border border-yellow-700/50 text-yellow-400 text-[10px] md:text-xs font-bold uppercase px-2 py-0.5 rounded-full" data-id="element-140">
                          {plan.savings}
                        </span>}
                    </div>}

                  <p className="text-emerald-300 text-sm md:text-base" data-id="element-141">
                    {plan.desc}
                  </p>
                </div>

                {/* Price */}
                <div className="flex-shrink-0 text-right" data-id="element-142">
                  <div className="text-gray-500 line-through text-xs md:text-sm font-medium mb-0.5" data-id="element-143">
                    {plan.originalPrice}
                  </div>
                  <div className={`text-2xl md:text-4xl font-extrabold tracking-tight ${isSelected && isPro ? 'text-yellow-400' : 'text-white'}`} data-id="element-144">
                    {plan.price}
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        {/* CTA Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center" data-id="element-145">
          <button onClick={handleCheckout} className="w-full bg-yellow-400 hover:bg-yellow-500 text-yellow-900 font-extrabold text-lg md:text-xl uppercase tracking-wide py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 mb-4" data-id="element-146">
            SÍ, QUIERO {plans[selectedPlan].name} →
          </button>

          <p className="text-emerald-400/80 italic text-sm mb-8" data-id="element-147">
            La opción más elegida por profesionales que buscan documentación
            completa
          </p>

          {/* Trust Badges */}
          <div className="bg-emerald-900/40 border border-emerald-800/60 rounded-xl py-3 px-4 flex flex-wrap items-center justify-center gap-4 md:gap-8 text-xs md:text-sm text-emerald-200 font-medium" data-id="element-148">
            <div className="flex items-center gap-1.5" data-id="element-149">
              <span data-id="element-150">🔒</span> Pago seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-151">
              <span data-id="element-152">⚡</span> Acceso en 5 min
            </div>
            <div className="flex items-center gap-1.5" data-id="element-153">
              <span data-id="element-154">🛡️</span> Garantía 7 días
            </div>
            <div className="flex items-center gap-1.5" data-id="element-155">
              <span data-id="element-156">💳</span> Mercado Pago
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}